<app-mixit-x509-banner/>
@if (alarm$ | async) {
  <app-alarm-bar [alarm]="alarm$"> </app-alarm-bar>
}

<app-schematics-tile
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [showShadow]="false"
  [dataPoints$]="dataPoints$">
</app-schematics-tile>

<app-heat-meter-status-tile
  [installation$]="installation$"
  [application]="application"
  [dataPoints$]="dataPoints$"
  [schematic$]="schematic$">
</app-heat-meter-status-tile>

@if (secondaryPump$ | async) {
  <app-pump-status-tile
    [title]="'pump-status-tile.secondary-pump' | translate"
    [installation$]="installation$"
    [application]="application"
    [pumpType$]="secondaryPumpType$"
    [pumpDevice$]="secondaryPump$"
    [pumpOptions]="secondaryPumpOptions$ | async">
  </app-pump-status-tile>
}

@if (circulationPump$ | async) {
  <app-pump-status-tile
    [title]="'pump-status-tile.circulation-pump' | translate"
    [installation$]="installation$"
    [application]="application"
    [pumpType$]="circulationPumpType$"
    [pumpDevice$]="circulationPump$"
    [pumpOptions]="circulationPumpOptions$ | async">
  </app-pump-status-tile>
}

@if (valveDevice$ | async) {
  <app-valve-status-tile
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id"
    [dataPoints$]="dataPoints$"
    [valveDevice$]="valveDevice$"
    [energyValve]="hasEnergyValve$ | async">
  </app-valve-status-tile>
}

@if (hasPrimaryTemperatureSensors$ | async) {
  <app-forward-return-chart-tile
    [title]="'mixing-loop-dashboard.primary-temp-chart-title' | translate"
    [applicationId]="application.id"
    forwardDumbledoreId="T_PF"
    returnDumbledoreId="T_PR"
    [dataPoints$]="dataPoints$">
  </app-forward-return-chart-tile>
}

<app-forward-return-chart-tile
  [title]="'mixing-loop-dashboard.secondary-temp-chart-title' | translate"
  [applicationId]="application.id"
  forwardDumbledoreId="T_SF"
  returnDumbledoreId="T_SR"
  [dataPoints$]="dataPoints$">
</app-forward-return-chart-tile>

<app-temperature-chart-tile
  [title]="'cascade-tank-dashboard.tank-one-temperatures' | translate"
  [applicationId]="application.id"
  [series]="tankOneChartSeries$ | async"
  [colors]="['#0068B4', '#009EE3', '#59B093']"
  [dataPoints$]="dataPoints$">
</app-temperature-chart-tile>

<app-temperature-chart-tile
  [title]="'cascade-tank-dashboard.tank-two-temperatures' | translate"
  [applicationId]="application.id"
  [series]="tankTwoChartSeries$ | async"
  [colors]="['#0068B4', '#009EE3', '#59B093']"
  [dataPoints$]="dataPoints$"
  >
</app-temperature-chart-tile>

<app-valve-chart
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [hasEnergyValve]="hasEnergyValve$ | async">
</app-valve-chart>

@if (hasEnergyValve$ | async) {
  <app-energy-valve-heat-and-flow-chart
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-energy-valve-heat-and-flow-chart>
}

@if (hasEnergyValve$ | async) {
  <app-energy-valve-temperature-chart
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-energy-valve-temperature-chart>
}

<app-differential-pressure-chart
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id">
</app-differential-pressure-chart>

<app-flow-heat-meter-chart-tile
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id">
</app-flow-heat-meter-chart-tile>

<app-water-meter-chart-tile
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id">
</app-water-meter-chart-tile>
